module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABVCAYAAAABkhkBAAAACXBIWXMAABYlAAAWJQFJUiTwAAABJklEQVR4nO3dQUrDQBiA0an0YLrIuTzYLOwReoTeRAnoVvmgGVt4D7L+k4/MIkNITnPO1zHGfvC72/k71LtQf7q8PPgJPhSxArECsQKxArECsQKxArECsQKxArECsQKxArECsQKxArECsYLzqkHbtp1WzTqKOysQKxArECsQKxArECsQKxArECsQKxArWPYgPef8XDXr3n42AdxZgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYwbLNvzHG28JZh1j5ytFl7aXdn2UYiBWIFYgViBWIFYgViBWIFYgViBWsfIvmY9Wsg1xX7jo8/QfNLMNArECsQKxArECsQKxArECsQKxArECsQKxArECsQKxArECsYN9Wvu2/HHiaM/4vY1y/ADaPEtq21IObAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/36.png
// module id = NZ+G
// module chunks = 1